'use client'

import { useClerk } from '@clerk/nextjs'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

/**
 * Fallback login page — redirects to primary domain using buildSignInUrl()
 * for proper satellite session sync while preserving redirect_url.
 */
export default function LoginRedirect() {
  const { buildSignInUrl } = useClerk()
  const searchParams = useSearchParams()

  useEffect(() => {
    const redirectUrl = searchParams.get('redirect_url') ?? window.location.origin
    const url = buildSignInUrl({ redirectUrl })

    window.location.replace(url)
  }, [buildSignInUrl, searchParams])

  return null
}
